import React from "react";
import { ArrowUpRight, Globe2, ShieldCheck } from "lucide-react";
import { BRAND } from "../../lib/constants";
import HeroSlideshow from "./HeroSlideshow";

export default function Hero() {
    return (
        <section
            id="top"
            className="relative pt-10 md:pt-16 pb-24 md:pb-32 overflow-hidden"
            data-testid="hero-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-8 md:gap-12 items-end">
                <div className="md:col-span-7 reveal">
                    <div className="overline mb-6" data-testid="hero-overline">
                        <span className="inline-block w-8 h-px bg-stone-400 align-middle mr-3"></span>
                        Healthcare · Pharma · Hospital Projects · Since 1999
                    </div>
                    <h1 className="font-cabinet font-black text-[13vw] md:text-[7.2vw] leading-[0.92] tracking-tight text-ink">
                        Exporting{" "}
                        <span className="italic font-normal text-[#4D7C0F]">
                            wellness
                        </span>
                        , <br className="hidden md:block" />
                        engineering{" "}
                        <span className="italic font-normal text-[#0C4A6E]">
                            hospitals
                        </span>
                        .
                    </h1>
                    <p className="mt-8 max-w-2xl text-lg md:text-xl text-stone-700 leading-relaxed reveal reveal-delay-1">
                        {BRAND.name} is a full-spectrum healthcare exporter —
                        from WHO-GMP pharmaceutical formulations and AYUSH
                        medicines to complete turnkey hospital planning, medical
                        equipment and infrastructure services — delivered to 45+
                        countries.
                    </p>

                    <div className="mt-10 flex flex-wrap items-center gap-4 reveal reveal-delay-2">
                        <a
                            href="#inquiry"
                            className="btn-primary"
                            data-testid="hero-cta-request-quote"
                        >
                            Request a Quotation
                            <ArrowUpRight size={18} strokeWidth={1.5} />
                        </a>
                        <a
                            href="#meeting"
                            className="btn-secondary"
                            data-testid="hero-cta-book-meeting"
                        >
                            Book a Zoom Meeting
                        </a>
                    </div>

                    <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 reveal reveal-delay-3">
                        <div className="flex items-center gap-2 text-sm text-stone-700">
                            <ShieldCheck
                                size={18}
                                strokeWidth={1.5}
                                className="text-[#0C4A6E]"
                            />
                            WHO-GMP · EU-GMP · PIC/S partners
                        </div>
                        <div className="flex items-center gap-2 text-sm text-stone-700">
                            <Globe2
                                size={18}
                                strokeWidth={1.5}
                                className="text-[#4D7C0F]"
                            />
                            Exports to Africa, CIS, LATAM, MENA, SE-Asia
                        </div>
                    </div>
                </div>

                <div className="md:col-span-5 reveal reveal-delay-2">
                    <div className="relative">
                        <div className="absolute -top-4 -left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 bg-[#FAF9F6] px-2 z-10">
                            01 / Capability
                        </div>
                        <HeroSlideshow />
                        <div className="absolute -bottom-6 -right-6 bg-white border border-stone-200 p-5 max-w-[220px] shadow-sm hidden md:block z-20">
                            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 mb-1">
                                Flagship
                            </div>
                            <div className="font-cabinet font-bold text-ink text-[17px] leading-tight">
                                Turnkey Hospital Project Delivery
                            </div>
                            <div className="mt-1 text-xs text-stone-600">
                                Planning → Equipping → Commissioning
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
